import { render } from "./manifesto.vue?vue&type=template&id=da991e2e&scoped=true&bindings={\"navigate\":\"props\"}"
import script from "./manifesto.vue?vue&type=script&lang=js"
export * from "./manifesto.vue?vue&type=script&lang=js"

import "./manifesto.vue?vue&type=style&index=0&id=da991e2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da991e2e"
/* custom blocks */
import block0 from "./manifesto.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script